<div class="min-h-screen bg-slate-50 p-4 font-sans antialiased text-xs">
      <div class="max-w-6xl mx-auto space-y-3">

            <div class="bg-white rounded-md shadow-sm border border-slate-200 p-3">
                  <div class="flex items-center justify-between">
                        <div>
                              <h2 class="text-sm font-bold text-slate-800 uppercase tracking-tight">Meta Entity
                                    Management</h2>
                              <p class="text-[10px] text-slate-500 uppercase">System Schema Configuration</p>
                        </div>

                        <div class="flex items-center gap-2">
                              <div class="relative">
                                    <span
                                          class="absolute inset-y-0 left-0 pl-2.5 flex items-center pointer-events-none text-slate-400">
                                          <svg class="h-3.5 w-3.5" fill="none" viewBox="0 0 24 24"
                                                stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                                          </svg>
                                    </span>
                                    <input type="text" [(ngModel)]="searchTerm" (input)="applyFilter()"
                                          placeholder="Search Entities..."
                                          class="w-48 pl-8 pr-2 py-1.5 border border-slate-200 rounded text-xs focus:ring-1 focus:ring-blue-500 outline-none" />
                              </div>

                              <button (click)="openCreateModal()"
                                    class="bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded font-semibold transition-all">
                                    + New Entity
                              </button>
                        </div>
                  </div>
            </div>

            <div class="bg-white rounded-md shadow-sm border border-slate-200 overflow-hidden">
                  <div class="overflow-x-auto">
                        <table class="w-full text-left border-collapse">
                              <thead>
                                    <tr
                                          class="bg-slate-50 border-b border-slate-200 text-slate-500 text-[10px] uppercase tracking-wider">
                                          <th class="px-3 py-2 font-bold" style="width: 15%">Code</th>
                                          <th class="px-3 py-2 font-bold" style="width: 25%">Entity Name</th>
                                          <th class="px-3 py-2 font-bold text-center" style="width: 10%">Mode</th>
                                          <th class="px-3 py-2 font-bold text-center" style="width: 8%">Ver</th>
                                          <th class="px-3 py-2 font-bold" style="width: 30%">Data Flow (JSON)</th>
                                          <th class="px-3 py-2 font-bold text-right" style="width: 12%">Actions</th>
                                    </tr>
                              </thead>
                              <tbody class="divide-y divide-slate-100">
                                    <tr *ngFor="let m of list" class="hover:bg-blue-50/50 transition-colors group">
                                          <td class="px-3 py-2 font-mono font-bold text-blue-700">{{ m.code }}</td>
                                          <td class="px-3 py-2 text-slate-700 font-medium">{{ m.name }}</td>
                                          <td class="px-3 py-2 text-center">
                                                <span
                                                      class="px-1.5 py-0.5 rounded bg-slate-100 border border-slate-200 text-slate-600 text-[10px]">{{
                                                      m.viewmode }}</span>
                                          </td>
                                          <td class="px-3 py-2 text-center">
                                                <span
                                                      class="px-2 py-0.5 rounded-full bg-emerald-100 text-emerald-700 font-bold text-[10px]">{{
                                                      m.version }}</span>
                                          </td>
                                          <td class="px-3 py-2">
                                                <p
                                                      class="truncate max-w-[200px] font-mono text-[10px] text-slate-400 bg-slate-50 px-1 rounded border border-slate-100">
                                                      {{ m.dataFlow }}</p>
                                          </td>
                                          <td class="px-3 py-2 text-right">
                                                <div class="flex justify-end gap-1 opacity-60 group-hover:opacity-100">
                                                      <button (click)="openEditModal(m)"
                                                            class="p-1 hover:text-blue-600 transition-colors"
                                                            title="Edit"><svg class="w-4 h-4" fill="none"
                                                                  stroke="currentColor" viewBox="0 0 24 24">
                                                                  <path d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                                                                        stroke-width="2" stroke-linecap="round"
                                                                        stroke-linejoin="round" />
                                                            </svg></button>
                                                      <button (click)="delete(m.id!)"
                                                            class="p-1 hover:text-red-600 transition-colors"
                                                            title="Delete"><svg class="w-4 h-4" fill="none"
                                                                  stroke="currentColor" viewBox="0 0 24 24">
                                                                  <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                                        stroke-width="2" stroke-linecap="round"
                                                                        stroke-linejoin="round" />
                                                            </svg></button>
                                                </div>
                                          </td>
                                    </tr>
                              </tbody>
                        </table>
                  </div>


                  <div
                        class="kt-card-footer flex flex-wrap items-center justify-between gap-4 px-4 py-2.5 bg-white border-t border-slate-200 text-xs font-medium">
                        <div class="flex items-center gap-3 text-sm font-bold text-black-600">
                              <span>Show</span>
                              <select [value]="pageSize" (change)="changePageSize($event)"
                                    class="kt-select w-20 border-2 border-slate-200 rounded-lg px-3 py-2 bg-white text-slate-800 font-bold outline-none focus:border-blue-500 transition-all cursor-pointer shadow-sm text-sm">
                                    <option [value]="5">5</option>
                                    <option [value]="10">10</option>
                                    <option [value]="25">25</option>
                                    <option [value]="50">50</option>
                              </select>
                              <span>per page</span>
                        </div>

                        <div class="flex items-center gap-6 text-black-600 font-medium">
                              <span class="hidden sm:inline-block text-sm">
                                    {{ total === 0 ? 0 : pageIndex * pageSize + 1 }}-{{ (pageIndex + 1) * pageSize >
                                    total ? total :
                                    (pageIndex + 1) * pageSize }}
                                    of {{ total }}
                              </span>

                              <div class="flex items-center gap-2">
                                    <button (click)="goToPage(pageIndex - 1)" [disabled]="pageIndex === 0"
                                          class="w-9 h-9 flex items-center justify-center rounded border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-30 disabled:hover:bg-transparent transition-colors shadow-sm text-slate-600">
                                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                      d="M15 19l-7-7 7-7">
                                                </path>
                                          </svg>
                                    </button>

                                    <div
                                          class="w-9 h-9 flex items-center justify-center bg-slate-100 border border-slate-200 rounded text-slate-900 font-bold text-sm shadow-inner">
                                          {{ pageIndex + 1 }}
                                    </div>

                                    <button (click)="goToPage(pageIndex + 1)" [disabled]="pageIndex >= totalPages - 1"
                                          class="w-9 h-9 flex items-center justify-center rounded border border-slate-300 bg-white hover:bg-slate-100 disabled:opacity-30 disabled:hover:bg-transparent transition-colors shadow-sm text-slate-600">
                                          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                      d="M9 5l7 7-7 7">
                                                </path>
                                          </svg>
                                    </button>
                              </div>
                        </div>
                  </div>
            </div>
      </div>
</div>

<div *ngIf="isModalOpen"
      class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-[2px]">
      <div
            class="bg-white rounded-lg shadow-xl w-full max-w-lg p-5 border border-slate-200 animate-in zoom-in duration-200">
            <div class="flex justify-between items-center border-b border-slate-100 pb-3 mb-4">
                  <h3 class="text-sm font-bold text-slate-800 uppercase tracking-tight">
                        {{ isEditMode ? 'Modify' : 'Create' }} Meta Entity
                  </h3>
                  <button (click)="closeModal()"
                        class="text-slate-400 hover:text-slate-600 transition-colors text-lg">✕</button>
            </div>

            <div class="grid grid-cols-2 gap-4">
                  <div class="col-span-1">
                        <label class="text-[10px] font-bold text-slate-500 uppercase mb-1 block">Entity Code</label>
                        <input [(ngModel)]="form.code"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none font-mono ">
                  </div>
                  <div class="col-span-1">
                        <label class="text-[10px] font-bold text-slate-500 uppercase mb-1 block">Entity Name</label>
                        <input [(ngModel)]="form.name"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none uppercase">
                  </div>
                  <div class="col-span-2">
                        <label class="text-[10px] font-bold text-slate-500 uppercase mb-1 block">View Mode</label>
                        <select [(ngModel)]="form.viewmode"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-xs focus:ring-1 focus:ring-blue-500 outline-none bg-white">
                              <option value="grid">Grid View</option>
                              <option value="form">Form View</option>
                              <option value="tab">Tab Layout</option>
                        </select>
                  </div>
                  <div class="col-span-2">
                        <label class="text-[10px] font-bold text-slate-500 uppercase mb-1 block">Data Flow (JSON
                              Configuration)</label>
                        <textarea [(ngModel)]="form.dataFlow" rows="4"
                              class="w-full border border-slate-200 rounded px-2 py-1.5 text-[11px] font-mono focus:ring-1 focus:ring-blue-500 outline-none bg-slate-50"
                              placeholder='{ "key": "value" }'></textarea>
                  </div>
            </div>

            <div class="flex justify-end gap-2 mt-6 pt-4 border-t border-slate-100">
                  <button (click)="closeModal()"
                        class="px-4 py-1.5 border border-slate-200 text-slate-600 rounded text-xs font-semibold hover:bg-slate-50 transition-colors">Cancel</button>
                  <button (click)="save()"
                        class="px-4 py-1.5 bg-blue-600 text-white rounded text-xs font-bold hover:bg-blue-700 shadow-sm transition-all">
                        {{ isEditMode ? 'UPDATE RECORD' : 'SAVE ENTITY' }}
                  </button>
            </div>
      </div>
</div>